import { Link } from "react-router-dom";

export const COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const SOBISCO_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
  },
  {
    Header: "Order Value",
    Footer: "Order Value",
    accessor: "netValue",
  },
  {
    Header: "Bill Link",
    Footer: "Bill Link",
    accessor: "billLink",
    Cell: ({ value }) => {
      if (!value) return "";
      return (
        <Link to={value}>
          <i className="fa-solid fa-download"></i>
        </Link>
      );
    },
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const FINODAYA_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Email",
    Footer: "Email",
    accessor: "email",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Description",
    Footer: "Description",
    accessor: "description",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const GENCREST_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "firstName",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Total Value",
    Footer: "Total Value",
    accessor: "totalAmount",
    sticky: "left",
  },

  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionDate",
    sticky: "left",
  },
  {
    Header: "UPI Id",
    Footer: "UPI Id",
    accessor: "upiId",
  },
  {
    Header: "UPI Name",
    Footer: "UPI Name",
    accessor: "upiName",
  },
  {
    Header: "Bank Name",
    Footer: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "Account Number",
    Footer: "Account Number",
    accessor: "accountNumber",
  },
  {
    Header: "IFSC Code",
    Footer: "IFSC Code",
    accessor: "ifscCode",
  },
  {
    Header: "Beneficiary Name",
    Footer: "Beneficiary Name",
    accessor: "beneficiaryName",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const STATIC_COLUMNS = [
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
    sticky: "left",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
    sticky: "left",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
    sticky: "left",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
    sticky: "left",
  },

  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

